import { Typography, Divider, Box } from '@mui/material';
import { Client, Contract } from '../types';

import {
    Datagrid,
    DateField,
    ListContextProvider,
    ResourceContextProvider,
    TextField,
    useGetMany,
    useGetManyReference,
    useList,
    useRecordContext,
    useTranslate,
    ReferenceField,

  } from 'react-admin';
import { PriceField } from '../components/PriceField';

const ClientLinkedFuneralsList = () => {
  const translate = useTranslate();
  const record = useRecordContext<Client>();

  const { data: dbFuneralDeceased } = useGetManyReference(
    'funerals',
    { target: 'deceased_client_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: dbFuneralPrimary } = useGetManyReference(
    'funerals',
    { target: 'primary_client_id', id: record?.id },
    { enabled: !!record }
  );

  const { data: dbFuneralClients, isLoading: isLoadingFuneralClients } = useGetManyReference(
    'funeral_clients',
    { target: 'client_id', id: record?.id },
    { enabled: !!record }
    // run only if the first query returns non-empty result
  );

  const { data: dbFuneralAdditional, isLoading: isLoadingFunerals } = useGetMany(
    'funerals',
    { ids: dbFuneralClients?.map(fc => fc.funeral_id) },
    { enabled: !isLoadingFuneralClients && !!dbFuneralClients }
    // run only if the first query returns non-empty result
  );



  const mergedfunerals = [...(dbFuneralDeceased || []), ...(dbFuneralPrimary || []), ...(dbFuneralAdditional || [])];

  const funerals =  [...new Map(mergedfunerals.map((item) => [item["id"], item])).values()];

  const listContext = useList({ data: funerals });
  return (
    <Box my={4}>
      <Typography variant='h6'>
        {translate('resources.funerals.name', { smart_count: funerals.length })}
      </Typography>
        <Divider />
        { funerals.length == 0 ? 
          <Typography mt={1}>No funerals</Typography>
         :
        <ResourceContextProvider value="funerals">
            <ListContextProvider value={listContext}>
                <Datagrid rowClick="show" bulkActionButtons={false}>
                    <TextField source="id" />
                    <ReferenceField source="deceased_client_id" reference="clients">
                        <TextField source="name" />
                    </ReferenceField>
                    <ReferenceField source="primary_client_id" reference="clients">
                        <TextField source="name" />
                    </ReferenceField>
                    <DateField source="funeral_date" />
            </Datagrid>
            </ListContextProvider>
        </ResourceContextProvider>
    }
    </Box>
  );
};

export default ClientLinkedFuneralsList;
